var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.51996 8.86766H8.9135L7.21184 7.12525L3.94128 7.12305C1.75661 7.12305 0 8.94043 0 11.207V15.0009H7.1999L8.87968 13.2794H6.51996V8.86766Z",
    fill: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.21576 6.24439C8.93035 6.24439 10.3203 4.84653 10.3203 3.12219C10.3203 1.39785 8.93035 0 7.21576 0C5.50116 0 4.11121 1.39785 4.11121 3.12219C4.11121 4.84653 5.50116 6.24439 7.21576 6.24439Z",
    fill: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.1735 7.14453H10.8051H9.31254L10.9937 8.86612L12.1111 10.0106H10.0311H7.7489L7.74914 12.1335H9.99637H12.0943L10.9778 13.2779L9.29806 14.9994H12.159L14.4462 12.6553L16 11.063L12.1735 7.14453Z",
    fill: "#A1A0A0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.f7f25a563720161583a458be55cb6016.svg";
export { ForwardRef as ReactComponent };